import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { UserService } from './../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
// import { SocialAuthService } from 'angularx-social-login';
// import { GoogleLoginProvider } from 'angularx-social-login';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import * as authActions from '../state/actions/authentication.actions';
import { AuthService } from 'src/app/services/auth.service';
// import { TawkService } from 'src/app/services/tawk.service';

/**
 *
 * Component used by visitors that will try to register to platform
 */
@Component({
   selector: 'app-signup',
   templateUrl: './signup.component.html',
   styleUrls: ['./signup.component.scss'],
})
export class SignUpComponent implements OnInit {
   /**
    * Form Group Used to store/read/validate inputs
    */
   individualSignupForm: FormGroup;
   signupForm: FormGroup;
   institutionalSignupForm: FormGroup;
   businessSignupForm: FormGroup;

   userInformationsIndex;
   marketing = false;
   profile = 'individual';
   siteKey;
   user: any;
   readMoreClicked;

   @ViewChild('readMoreIndividual') readMoreIndividual: ElementRef;
   @ViewChild('readMoreInstitution') readMoreInstitution: ElementRef;
   @ViewChild('readMoreBusiness') readMoreBusiness: ElementRef;

   /**
 * Used to store accessCode
 */
   linkedInToken: string;
   invalidEmail: boolean;
   /**
    * Component constructor
    * @param dialog
    * @param fb
    * @param userService
    * @param toastrService
    * @param spinnerService
    * @param router
    */
   constructor(
      public dialog: MatDialog,
      private fb: FormBuilder,
      private toastrService: ToastrService,
      private router: Router,
      private userService: UserService,
      private route: ActivatedRoute,
      private spinner: NgxSpinnerService,
      // private socialAuthService: SocialAuthService,
      private store: Store,
      private renderer: Renderer2,
      private authService: AuthService
      // private tawkService: TawkService,
   ) {
   }
   /**
    * Method used to be called whenever the component is loaded and all the methods in it, will be triggered.
    */
   ngOnInit(): void {
      // this.tawkService.SetChatVisibility(true);

      if (this.authService.isLoggedIn()) {
         if (this.authService.isLoggedInRole() == '2') {
            this.router.navigateByUrl('/individual');
         } else if (this.authService.isLoggedInRole() == '1') {
            this.router.navigateByUrl('/admin');
         } else if (this.authService.isLoggedInRole() == '3' || this.authService.isLoggedInRole() == '11') {
            this.router.navigateByUrl('/administrator');
         } else if (this.authService.isLoggedInRole() == '4') {
            this.router.navigateByUrl('/professor');
         } else if (this.authService.isLoggedInRole() == '6' || this.authService.isLoggedInRole() == '10') {
            this.router.navigateByUrl('/vleresues');
         } else if (this.authService.isLoggedInRole() == '7') {
            this.router.navigateByUrl('/super-admin');
         } else if (this.authService.isLoggedInRole() == '5' || this.authService.isLoggedInRole() == '9') {
            this.router.navigateByUrl('/student');
         }
      }
      // this.profile = this.route.snapshot.paramMap.get('profile');
      this.linkedInToken = this.route.snapshot.queryParams['code'];
      this.userInformationsIndex = 0;
      this.siteKey = "6LcyfH0pAAAAAFYgdP85R9g43SkmYluDaLuFEqJo";
      this.individualSignupForm = this.fb.group({
         first_name: [
            '',
            [
               Validators.required,
               Validators.pattern('^[a-zA-Z ]*$'),
               Validators.minLength(3),
            ],
         ],
         last_name: [
            '',
            [
               Validators.required,
               Validators.pattern('^[a-zA-Z ]*$'),
               Validators.minLength(3),
            ],
         ],
         email: ['', [Validators.required, Validators.email]],
         agree: [false, [Validators.requiredTrue]],
         recaptcha: ['']
      });

      this.businessSignupForm = this.fb.group({
         first_name: [
            '',
            [
               Validators.required,
               Validators.pattern('^[a-zA-Z ]*$'),
               Validators.minLength(3),
            ],
         ],
         last_name: [
            '',
            [
               Validators.required,
               Validators.pattern('^[a-zA-Z ]*$'),
               Validators.minLength(3),
            ],
         ],
         email: ['', [Validators.required, Validators.email]],
         role: ['', [Validators.required]],
         company: ['', [Validators.required]],
         country: ['', [Validators.required]],
         agree: [false, [Validators.requiredTrue]],
         recaptcha: ['', [Validators.required]],
         message: ['', [Validators.required]],
      });

      this.institutionalSignupForm = this.fb.group({
         first_name: [
            '',
            [
               Validators.required,
               Validators.pattern('^[a-zA-Z ]*$'),
               Validators.minLength(3),
            ],
         ],
         last_name: [
            '',
            [
               Validators.required,
               Validators.pattern('^[a-zA-Z ]*$'),
               Validators.minLength(3),
            ],
         ],
         email: ['', [Validators.required, Validators.email]],
         role: ['', [Validators.required]],
         institution: ['', [Validators.required]],
         country: ['', [Validators.required]],
         currentSystem: [''],
         agree: [false, [Validators.required]],
         recaptcha: ['', [Validators.required]]
      });

      if (this.profile == 'individual') {
         this.signupForm = this.individualSignupForm
      } else if (this.profile == 'institution') {
         this.signupForm = this.institutionalSignupForm
      } else if (this.profile == 'business') {
         this.signupForm = this.businessSignupForm
      }
   }
   /**
    * Method used to get controls from formGroup
    */
   get form() {
      return this.signupForm.controls;
   }
   /**
    * Method used to show a toaster with a success message to the user.
    * @param message
    */
   showToasterSuccess(message) {
      this.toastrService.success(message);
   }
   /**
    * Method used to show a toaster with a warning message to the user.
    * @param message
    */
   showToasterWarning(message) {
      this.toastrService.warning(message);
   }

   acceptMarketing() {
      this.marketing = !this.marketing;
   }
   /**
    * Method used to call signup api and sends parameters like firstName, lastName and email
    */
   signUp() {
      let disposableEmails = [
         '0815.ru0clickemail.com', '0wnd.net', '0wnd.org', '10minutemail.com', '20minutemail.com', '2prong.com', '3d-painting.com', '4warding.com', '4warding.net', '4warding.org', '9ox.net', 'a-bc.net', 'amilegit.com', 'anonbox.net', 'anonymbox.com', 'antichef.com', 'antichef.net', 'antispam.de', 'baxomale.ht.cx', 'beefmilk.com', 'binkmail.com', 'bio-muesli.net', 'bobmail.info', 'bodhi.lawlita.com', 'bofthew.com', 'brefmail.com', 'bsnow.net', 'bugmenot.com', 'bumpymail.com', 'casualdx.com', 'chogmail.com', 'cool.fr.nf', 'correo.blogos.net', 'cosmorph.com', 'courriel.fr.nf', 'courrieltemporaire.com', 'curryworld.de', 'cust.in', 'dacoolest.com', 'dandikmail.com', 'deadaddress.com', 'despam.it', 'devnullmail.com', 'dfgh.net', 'digitalsanctuary.com', 'discardmail.com', 'discardmail.de', 'disposableaddress.com', 'disposemail.com', 'dispostable.com', 'dm.w3internet.co.uk', 'example.com', 'dodgeit.com', 'dodgit.com', 'dodgit.org', 'dontreg.com', 'dontsendmespam.de', 'dump-email.info', 'dumpyemail.com', 'e4ward.com', 'email60.com', 'emailias.com', 'emailinfive.com', 'emailmiser.com', 'emailtemporario.com.br', 'emailwarden.com', 'ephemail.net', 'explodemail.com', 'fakeinbox.com', 'fakeinformation.com', 'fastacura.com', 'filzmail.com', 'fizmail.com', 'frapmail.com', 'garliclife.com', 'get1mail.com', 'getonemail.com', 'getonemail.net', 'girlsundertheinfluence.com', 'gishpuppy.com', 'great-host.in', 'gsrv.co.uk', 'guerillamail.biz', 'guerillamail.com', 'guerillamail.net', 'guerillamail.org', 'guerrillamail.com', 'guerrillamailblock.com', 'haltospam.com', 'hotpop.com', 'ieatspam.eu', 'ieatspam.info', 'ihateyoualot.info', 'imails.info', 'inboxclean.com', 'inboxclean.org', 'incognitomail.com', 'incognitomail.net', 'ipoo.org', 'irish2me.com', 'jetable.com', 'jetable.fr.nf', 'jetable.net', 'jetable.org', 'junk1e.com', 'kaspop.com', 'kulturbetrieb.info', 'kurzepost.de', 'lifebyfood.com', 'link2mail.net', 'litedrop.com', 'lookugly.com', 'lopl.co.cc', 'lr78.com', 'maboard.com', 'mail.by', 'mail.mezimages.net', 'mail4trash.com', 'mailbidon.com', 'mailcatch.com', 'maileater.com', 'mailexpire.com', 'mailin8r.com', 'mailinator.com', 'mailinator.net', 'mailinator2.com', 'mailincubator.com', 'mailme.lv', 'mailnator.com', 'mailnull.com', 'mailzilla.org', 'mbx.cc', 'mega.zik.dj', 'meltmail.com', 'mierdamail.com', 'mintemail.com', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'mt2009.com', 'mx0.wwwnew.eu', 'mycleaninbox.net', 'mytrashmail.com', 'neverbox.com', 'nobulk.com', 'noclickemail.com', 'nogmailspam.info', 'nomail.xl.cx', 'nomail2me.com', 'no-spam.ws', 'nospam.ze.tc', 'nospam4.us', 'nospamfor.us', 'nowmymail.com', 'objectmail.com', 'obobbo.com', 'onewaymail.com', 'ordinaryamerican.net', 'owlpic.com', 'pookmail.com', 'proxymail.eu', 'punkass.com', 'putthisinyourspamdatabase.com', 'quickinbox.com', 'rcpt.at', 'recode.me', 'recursor.net', 'regbypass.comsafe-mail.net', 'safetymail.info', 'sandelf.de', 'saynotospams.com', 'selfdestructingmail.com', 'sendspamhere.com', 'shiftmail.com', '****mail.me', 'skeefmail.com', 'slopsbox.com', 'smellfear.com', 'snakemail.com', 'sneakemail.com', 'sofort-mail.de', 'sogetthis.com', 'soodonims.com', 'spam.la', 'spamavert.com', 'spambob.net', 'spambob.org', 'spambog.com', 'spambog.de', 'spambog.ru', 'spambox.info', 'spambox.us', 'spamcannon.com', 'spamcannon.net', 'spamcero.com', 'spamcorptastic.com', 'spamcowboy.com', 'spamcowboy.net', 'spamcowboy.org', 'spamday.com', 'spamex.com', 'spamfree24.com', 'spamfree24.de', 'spamfree24.eu', 'spamfree24.info', 'spamfree24.net', 'spamfree24.org', 'spamgourmet.com', 'spamgourmet.net', 'spamgourmet.org', 'spamherelots.com', 'spamhereplease.com', 'spamhole.com', 'spamify.com', 'spaminator.de', 'spamkill.info', 'spaml.com', 'spaml.de', 'spammotel.com', 'spamobox.com', 'spamspot.com', 'spamthis.co.uk', 'spamthisplease.com', 'speed.1s.fr', 'suremail.info', 'tempalias.com', 'tempemail.biz', 'tempemail.com', 'tempe-mail.com', 'tempemail.net', 'tempinbox.co.uk', 'tempinbox.com', 'tempomail.fr', 'temporaryemail.net', 'temporaryinbox.com', 'thankyou2010.com', 'thisisnotmyrealemail.com', 'throwawayemailaddress.com', 'tilien.com', 'tmailinator.com', 'tradermail.info', 'trash2009.com', 'trash-amil.com', 'trashmail.at', 'trash-mail.at', 'trashmail.com', 'trash-mail.com', 'trash-mail.de', 'trashmail.me', 'trashmail.net', 'trashymail.com', 'trashymail.net', 'tyldd.com', 'uggsrock.com', 'wegwerfmail.de', 'wegwerfmail.net', 'wegwerfmail.org', 'wh4f.org', 'whyspam.me', 'willselfdestruct.com', 'winemaven.info', 'wronghead.com', 'wuzupmail.net', 'xoxy.net', 'yogamaven.com', 'yopmail.com', 'yopmail.fr', 'yopmail.net', 'yuurok.com', 'zippymail.info', 'jnxjn.com', 'trashmailer.com', 'klzlk.com', 'nospamforus', 'kurzepost.de', 'objectmail.com', 'proxymail.eu', 'rcpt.at', 'trash-mail.at', 'trashmail.at', 'trashmail.me', 'trashmail.net', 'wegwerfmail.de', 'wegwerfmail.net', 'wegwerfmail.org', 'jetable', 'link2mail', 'meltmail', 'anonymbox', 'courrieltemporaire', 'sofimail', '0-mail.com', 'moburl.com', 'get2mail', 'yopmail', '10minutemail', 'mailinator', 'dispostable', 'spambog', 'mail-temporaire', 'filzmail', 'sharklasers.com', 'guerrillamailblock.com', 'guerrillamail.com', 'guerrillamail.net', 'guerrillamail.biz', 'guerrillamail.org', 'guerrillamail.de', 'mailmetrash.com', 'thankyou2010.com', 'trash2009.com', 'mt2009.com', 'trashymail.com', 'mytrashmail.com', 'mailcatch.com', 'trillianpro.com', 'junk.', 'joliekemulder', 'lifebeginsatconception', 'beerolympics', 'smaakt.naar.gravel', 'q00.', 'dispostable', 'spamavert', 'mintemail', 'tempemail', 'spamfree24', 'spammotel', 'spam', 'mailnull', 'e4ward', 'spamgourmet', 'mytempemail', 'incognitomail', 'spamobox', 'mailinator.com', 'trashymail.com', 'mailexpire.com', 'temporaryinbox.com', 'MailEater.com', 'spambox.us', 'spamhole.com', 'spamhole.com', 'jetable.org', 'guerrillamail.com', 'uggsrock.com', '10minutemail.com', 'dontreg.com', 'tempomail.fr', 'TempEMail.net', 'spamfree24.org', 'spamfree24.de', 'spamfree24.info', 'spamfree24.com', 'spamfree.eu', 'kasmail.com', 'spammotel.com', 'greensloth.com', 'spamspot.com', 'spam.la', 'mjukglass.nu', 'slushmail.com', 'trash2009.com', 'mytrashmail.com', 'mailnull.com', 'jetable.org', '10minutemail.com', '20minutemail.com', 'anonymbox.com', 'beefmilk.com', 'bsnow.net', 'bugmenot.com', 'deadaddress.com', 'despam.it', 'disposeamail.com', 'dodgeit.com', 'dodgit.com', 'dontreg.com', 'e4ward.com', 'emailias.com', 'emailwarden.com', 'enterto.com', 'gishpuppy.com', 'goemailgo.com', 'greensloth.com', 'guerrillamail.com', 'guerrillamailblock.com', 'hidzz.com', 'incognitomail.net ', 'jetable.org', 'kasmail.com', 'lifebyfood.com', 'lookugly.com', 'mailcatch.com', 'maileater.com', 'mailexpire.com', 'mailin8r.com', 'mailinator.com', 'mailinator.net', 'mailinator2.com', 'mailmoat.com', 'mailnull.com', 'meltmail.com', 'mintemail.com', 'mt2009.com', 'myspamless.com', 'mytempemail.com', 'mytrashmail.com', 'netmails.net', 'odaymail.com', 'pookmail.com', 'shieldedmail.com', 'smellfear.com', 'sneakemail.com', 'sogetthis.com', 'soodonims.com', 'spam.la', 'spamavert.com', 'spambox.us', 'spamcero.com', 'spamex.com', 'spamfree24.com', 'spamfree24.de', 'spamfree24.eu', 'spamfree24.info', 'spamfree24.net', 'spamfree24.org', 'spamgourmet.com', 'spamherelots.com', 'spamhole.com', 'spaml.com', 'spammotel.com', 'spamobox.com', 'spamspot.com', 'tempemail.net', 'tempinbox.com', 'tempomail.fr', 'temporaryinbox.com', 'tempymail.com', 'thisisnotmyrealemail.com', 'trash2009.com', 'trashmail.net', 'trashymail.com', 'tyldd.com', 'yopmail.com', 'zoemail.com', 'deadaddress', 'soodo', 'tempmail', 'uroid', 'spamevader', 'gishpuppy', 'privymail.de', 'trashmailer.com', 'fansworldwide.de', 'onewaymail.com', 'mobi.web.id', 'ag.us.to', 'gelitik.in', 'fixmail.tk', 'shitmail.org'
      ];

      if (disposableEmails.includes(this.signupForm.value.email.split('@')[1])) {
         this.invalidEmail = true;
         return;
      } else {
         this.invalidEmail = false;
      }

      this.spinner.show();
      let first_name =
         this.signupForm.value.first_name.substr(0, 1).toUpperCase() +
         this.signupForm.value.first_name.substr(1);
      let last_name =
         this.signupForm.value.last_name.substr(0, 1).toUpperCase() +
         this.signupForm.value.last_name.substr(1);
      this.userService
         .signUp(
            first_name,
            last_name,
            this.signupForm.value.email,
            this.signupForm.value.institution,
            this.marketing,
            this.signupForm.value.role,
            this.signupForm.value.country,
            this.signupForm.value.currentSystem,
            this.signupForm.value.company,
            this.signupForm.value.message,
         )
         .pipe(first())
         .subscribe(
            (data) => {
               this.router.navigateByUrl(
                  `/email-confirmation/${this.signupForm.value.email}`
               );
               this.spinner.hide();
               // if(data.institutionId) {
               //    this.notifyInstitutionAlert();
               // } else if(!data.message) {
               //    this.notifyUserAlert();
               // } else if(data.message){
               //    this.notifyBussinessAlert();
               // }

            },
            (error) => {
               swal.fire({
                  title: 'Oops, there was a problem!',
                  html: 'Something went wrong while signing you up. Please reload the page and try again.',
                  icon: 'warning',
               });
               this.spinner.hide();
               console.log('error', error);
            }
         );
   }
   async notifyUserAlert() {
      swal.fire({
         title: 'You have been successfully registered in Inspera Originality!',
         html: 'Please check your email to verify your account. Upon activation you get <b>10 credits free</b>  for one document',
         icon: 'success',
      });
      // this.router.navigateByUrl('/login');
   }

   async notifyInstitutionAlert() {
      swal.fire({
         title: 'You have been successfully registered in Inspera Originality!',
         html: 'Please check your email to verify your account. We will review your registration and set up a free trial for your institution.',
         icon: 'success',
      });
      // this.router.navigateByUrl('/login');
   }

   async notifyBussinessAlert() {
      swal.fire({
         title: 'Thank you for contacting us',
         html: 'After reviewing your email we will sent you an email',
         icon: 'success',
      });
      // this.router.navigateByUrl('/login');
   }
   /**
    * Method used to open terms & conditions component in modal.
    */
   openModal() {
      this.dialog.open(TermsAndConditionsComponent, {
         width: '70%',
      });
   }
   resolved(captchaResponse: string) {
      console.log(`Resolved captcha with response: ${captchaResponse}`);
   }
   /**
* Method used to sign in with google,
* calls socialAuthService that returns Social User
* then dispaches the googleLogin action with user name and email
*/
   // async signInWithGoogle() {
   //    const userData = this.socialAuthService.signIn(
   //       GoogleLoginProvider.PROVIDER_ID
   //    );
   //    // Now sign-in with userData
   //    if (userData != null) {
   //       this.user = await userData;
   //       this.store.dispatch(
   //          authActions.googleLogin({
   //             name: this.user?.name,
   //             email: this.user?.email,
   //          })
   //       );
   //    }
   // }
   /**
    * Method used to redirect user to linkedIn to get authCode
    */
   loginLinkedin() {
      window.location.href = `https://www.linkedin.com/uas/oauth2/authorization?response_type=code&scope=r_liteprofile%20r_emailaddress&client_id=${environment.linkedInKey}&redirect_uri=${environment.currentUrl}`;
   }
   /**
    * Method called after we get authcode from linkedIn,
    * Dispaches linkedInLogin action
    */
   linkedInAuth() {
      this.store.dispatch(
         authActions.linkedInLogin({ authCode: this.linkedInToken })
      );
   }

   async changeRoute(route) {
      this.router.navigate([`sign-up/${route}`]);
      //   await this.renderer.listen('window', 'click', (e: Event) => {
      //       if (
      //          e.target !== this.readMoreIndividual.nativeElement &&  e.target !== this.readMoreInstitution.nativeElement &&  e.target !== this.readMoreBusiness.nativeElement
      //       ) {
      //          this.router.navigate([`sign-up/${route}`]);
      //       }
      //    });
   }

   checkEmail() {

   }
}
